export default class MultipleButtons {
    constructor() {
        
    }
}

new MultipleButtons();


// WEBPACK FOOTER //
// ../views/modules/multiple-buttons/assets/js/multiple-buttons.js